import { RotateCcw } from "lucide-react";
import { COLOR_PRESETS, NEUTRAL, buildChain, chainToCss } from "../../lib/filters";
import { posterUrl } from "../../lib/api";
import { useLang } from "../../lib/i18n";

const SLIDERS = ["brightness", "contrast", "saturate"];

export const ColorsTab = ({ file, state, setState }) => {
  const { t } = useLang();
  const set = (patch) => setState({ ...state, ...patch });
  return (
    <div className="frz-tabpane" data-testid="tabpane-colors">
      <h4 className="frz-label">{t("filters")}</h4>
      <div className="frz-swatches">
        {COLOR_PRESETS.map((p) => (
          <button key={p.id} type="button" className={`frz-swatch ${state.preset === p.id ? "on" : ""}`} onClick={() => set({ preset: p.id })} data-testid={`filter-preset-${p.id}`}>
            <img src={posterUrl(file)} alt="" style={{ filter: chainToCss(buildChain({ ...NEUTRAL, preset: p.id })) }} />
            <span>{t(`preset_${p.id}`)}</span>
          </button>
        ))}
      </div>
      {SLIDERS.map((k) => (
        <label key={k} className="frz-slider">
          <span>{t(k)} <b data-testid={`slider-${k}-value`}>{state[k]}%</b></span>
          <input type="range" min="0" max="200" value={state[k]} onChange={(e) => set({ [k]: Number(e.target.value) })} data-testid={`slider-${k}`} />
        </label>
      ))}
      <div className="frz-toggles">
        {["sepia", "bw"].map((k) => (
          <button key={k} type="button" role="switch" aria-checked={state[k]} className={`frz-toggle ${state[k] ? "on" : ""}`} onClick={() => set({ [k]: !state[k] })} data-testid={`toggle-${k}`}>
            <span className="frz-toggle-dot" /> {t(k)}
          </button>
        ))}
      </div>
      <button type="button" className="frz-btn frz-btn-ghost frz-btn-block" onClick={() => setState(NEUTRAL)} data-testid="button-reset-colors">
        <RotateCcw size={15} /> {t("reset")}
      </button>
    </div>
  );
};
